module.exports = __webpack_public_path__ + "static/homeVideoMobile-muted-c3c95a104dd5768e6eb5f310e9fddf22.mp4";